import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { helper } from 'src/environments/helper';
import { StatusService } from '../status.service';
import { Status } from '../status.interface';

@Component({
    selector: 'app-add-status-cerere',
    templateUrl: './add-status-cerere.component.html',
    styleUrls: ['./add-status-cerere.component.scss'],
})
export class AddStatusCerereComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    filterParameter: { name: string; id: number } = {
        name: '--Alegeți--',
        id: -1,
    };

    form: FormGroup = new FormGroup({
        name: new FormControl('', [Validators.required]),
        color: new FormControl('#f44336', [Validators.required]),
        observatii: new FormControl('', []),
    });

    constructor(
        private dialogRef: MatDialogRef<AddStatusCerereComponent>,
        private requestService: StatusService,
        private notificationService: NotificationService,
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    ngOnInit() { }

    submitForm() {
        this.isLoading = true;


        const { name, color, observatii } = this.form.value;
        const payload: Status = {
            name, color, observatii
        };

        this.requestService
            .storeEntry(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
